import { Breakpoint, useMediaQuery } from '@mui/material';
import { SolTheme } from '../theme/SolThemeProvider';

export function useBreakpoint(
  boundary: 'mdDown' | 'mdUp' | 'smDown' | 'smUp'
): boolean {
  const type = boundary.substring(2) === 'Up' ? 'up' : 'down';
  const breakpoint = boundary.substring(0, 2) as Breakpoint;

  const status = useMediaQuery<SolTheme>((theme) =>
    theme.breakpoints[type](breakpoint)
  );

  return status;
}

export default useBreakpoint;
